import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { TrackingProductModel } from "@omni/types/components/tracking/models/trackingProduct.model";
import { AddToWishlishtTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToWishlist.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: AddToWishlishtTrackingInfo) => {
    const event: TypedAnalyticsEvent<AddToWishlishtTrackingInfo> = {
        event: EventType.AddToWishlist,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackProduct = (product: TrackingProductModel) => {
    track(product);
};
